export default "__VITE_ASSET__15302ecb__"